/* aw-variant.js — de kleurkiezer als foto's, en de gekozen waarde in het label.
 *
 * De bron toont per kleur de VARIANTFOTO in een vakje van 82x82 met een rand
 * van 1px: de gekozen kleur krijgt de inktkleur, de rest rgb(227,220,209).
 * Naast het woord "Colour:" staat daar de naam van de gekozen kleur.
 *
 * Horizons variantkiezer blijft ongemoeid — die doet de formulierstaat, de
 * beschikbaarheid en het wisselen. Wij hangen er alleen een achtergrondfoto
 * achter en schrijven de gekozen waarde in de legenda.
 */
(() => {
  const KAART = (() => {
    const el = document.getElementById('aw-variant-fotos');
    if (!el) return {};
    try { return JSON.parse(el.textContent); } catch (e) { return {}; }
  })();

  function zetFotos(wortel) {
    (wortel || document).querySelectorAll('fieldset.variant-option').forEach((veld) => {
      const eersteInvoer = veld.querySelector('input[data-option-name]');
      if (!eersteInvoer) return;
      const optie = eersteInvoer.getAttribute('data-option-name');
      const fotos = KAART[optie];
      if (!fotos) return;

      veld.classList.add('aw-kleurveld');
      veld.querySelectorAll('label').forEach((label) => {
        const invoer = label.querySelector('input');
        if (!invoer) return;
        const url = fotos[invoer.value];
        if (!url) return;
        if (label.dataset.awFoto === url) return;
        label.dataset.awFoto = url;
        label.style.backgroundImage = 'url(' + url + ')';
      });
    });
  }

  function zetLegenda(wortel) {
    (wortel || document).querySelectorAll('fieldset.variant-option').forEach((veld) => {
      const legenda = veld.querySelector('legend');
      if (!legenda) return;
      const gekozen = veld.querySelector('input:checked');
      if (!gekozen) return;
      /* De bron zet een dubbele punt achter het woord: "Colour:", "Size:".
         Horizon laat alleen "Colour" staan.

         ALLEEN de losse tekst van de legenda lezen, nooit `textContent`. In de
         legenda hangen namelijk elementen: bij een kiezer met stalen zet
         Horizon zelf al een `<span class="variant-option__swatch-value">` met
         de gekozen waarde erin, en bij de maat hangt onze maattabelknop erin.
         Met `textContent` lees je die mee, en dan wordt het woord
         "ColourBrown" en de hele regel "ColourBrown: Brown". Dat stond zo op
         elk product met kleurstalen. */
      const woord = [...legenda.childNodes]
        .filter((n) => n.nodeType === 3)
        .map((n) => n.textContent)
        .join('');
      const metDubbelePunt = woord.trim().replace(/:\s*$/, '') + ':';

      /* De GEKOZEN WAARDE staat er alleen bij de kleuren. Gemeten op de bron:
         de kleurregel is "Colour: Blue", de maatregel is kaal "Size:". Dat is
         geen slordigheid van de bron maar zijn regel: hij toont de waarde
         alleen bij een kiezer met stalen of variantfoto's. Zet je hem overal,
         dan wordt de maatlegenda breder en schuift de maattabelknop mee. */
      const toonWaarde = veld.classList.contains('aw-kleurveld');
      let waarde = legenda.querySelector('.aw-optie-waarde');

      if (!toonWaarde) {
        if (waarde) waarde.remove();
        if (legenda.firstChild && legenda.firstChild.nodeType === 3
            && legenda.firstChild.textContent !== metDubbelePunt) {
          legenda.firstChild.textContent = metDubbelePunt;
        }
        return;
      }

      if (!waarde) {
        legenda.textContent = metDubbelePunt;
        waarde = document.createElement('span');
        waarde.className = 'aw-optie-waarde';
        legenda.appendChild(waarde);
      }
      const nieuweTekst = ' ' + gekozen.value;
      if (waarde.textContent !== nieuweTekst) waarde.textContent = nieuweTekst;
    });
  }


  /* ── De maattabelknop ─────────────────────────────────────────────────────
     De bron zet naast het woord "Size" een knop die de maattabel opent. Bij
     Horizon ligt de opbouw van die regel vast in `variant-main-picker.liquid`,
     en dat bestand raken we niet aan. De knop wordt daarom hier in de legenda
     gekloond uit het sjabloon dat `blocks/aw-maattabel.liquid` neerzet.

     Twee dingen om te weten:

     - Dit MOET na `zetLegenda` draaien. Die schrijft `legenda.textContent` als
       de gekozen waarde er nog niet in staat, en dat gooit alles weg wat er in
       de legenda hangt, dus ook deze knop.
     - De bron toont de knop alleen bij een optie die letterlijk "Size" heet, en
       daardoor krijgen de schoenen (optie "Shoe Size") er geen. Wij toetsen op
       "size" ergens in de naam, zodat de schoenen hem ook krijgen. Dat is geen
       gok: de tabel zelf weigert te renderen als hij niet zeker weet waar het
       product over gaat, en bij schoenen eist hij bovendien maten die op een
       cijfer beginnen. Weet hij het niet, dan komt er geen knop. */
  function zetMaattabel() {
    const sjabloon = document.getElementById('aw-sgc-sjabloon');
    if (!sjabloon) return;
    const hoofd = document.querySelector('.product-information');
    if (!hoofd) return;

    hoofd.querySelectorAll('fieldset.variant-option').forEach((veld) => {
      /* Niet in de snelkoop of een ander venster: daar staat het venster zelf
         niet op de pagina en zou de knop niets doen. */
      if (veld.closest('dialog, .quick-add-modal')) return;
      const eersteInvoer = veld.querySelector('input[data-option-name]');
      if (!eersteInvoer) return;
      const naam = (eersteInvoer.getAttribute('data-option-name') || '').toLowerCase();
      if (naam.indexOf('size') < 0 && naam.indexOf('maat') < 0) return;

      const legenda = veld.querySelector('legend');
      if (!legenda || legenda.querySelector('.aw-sgc-link')) return;
      legenda.appendChild(sjabloon.content.firstElementChild.cloneNode(true));
    });
  }

  /* De waarnemer MOET losgekoppeld zijn terwijl we schrijven. Zonder dat gaat
     het mis: `legenda.textContent = ...` en `waarde.textContent = ...` zijn
     allebei een childList-wijziging, dus de waarnemer vuurt op zijn eigen
     schrijfactie en de lus loopt eeuwig door. De pagina laadde daardoor niet
     meer klaar. */
  let waarnemer = null;
  let bezig = false;

  function alles() {
    if (bezig) return;
    bezig = true;
    if (waarnemer) waarnemer.disconnect();
    try { zetFotos(); zetLegenda(); zetMaattabel(); }
    finally {
      if (waarnemer) waarnemer.observe(document.documentElement, { childList: true, subtree: true });
      bezig = false;
    }
  }

  alles();
  document.addEventListener('change', () => setTimeout(alles, 30), true);
  document.addEventListener('shopify:section:load', alles);
  waarnemer = new MutationObserver(() => alles());
  waarnemer.observe(document.documentElement, { childList: true, subtree: true });
})();
